import { CLASS_CONTROL, CLASS_UNSELECTABLE } from 'ol/css';

import { AbstractLayerControl, AbstractLayerEntry } from './abstract_layer_control';
import { WMSLayer } from '../wms_layer';

import { faCircleNotch } from '@fortawesome/pro-solid-svg-icons';
import { icon } from '@fortawesome/fontawesome-svg-core'

import './loading_indicator.css';

const LOADING_TIMEOUT = 1500;

class LoadingEntry extends AbstractLayerEntry {
	constructor( layer, parent ) {
		super(layer);
		this.control = parent;
		this.timerId = null;
		this.loading = false;
				
		if( this.instance instanceof WMSLayer ) {			
				
			this.listen(this.source.on("imageloadstart", (e) => {				
				clearTimeout(this.timerId);
				this.timerId = setTimeout(() => this.updateLoadingState(true), LOADING_TIMEOUT);			
			}));
			
			this.listen(this.source.on(['imageloadend', 'imageloaderror'], () => {
				this.updateLoadingState(false);			
			}));		
		}
	}
	
	isLoading() {
		return this.loading;	
	}
	
	updateLoadingState(loading) {
		if( !loading ) {
			clearTimeout(this.timerId);		
		}
		
		this.loading = loading;
		this.control.refreshControl();
	}	

	remove() {
		super.remove();
	}
}

class LoadingIndicator extends AbstractLayerControl {

	constructor( opt_options ) {
		const options = opt_options ? opt_options : {};
	
		super(options);
				
		const className = options.className !== undefined ? options.className : 'ol-loading-indicator';
		const containerElement = this.element;
		
		containerElement.className = `${className} ${CLASS_UNSELECTABLE} ${CLASS_CONTROL}`;
		
		const inner = document.createElement("span");
		inner.className = `${className}-inner`;
		
		this.inner = inner;
		
		const spinner =  icon(faCircleNotch, {
  					classes: ['fa-spin']
		}).node[0];
				
		containerElement.appendChild( spinner );
		containerElement.appendChild(inner);
		
	}
		
	createEntry( layer ) {
		 return new LoadingEntry(layer, this);
	}	
	
	refresh() {
		this.refreshControl();
	}
	
	refreshControl() {
		const loadingLayers = this.getLayers()
		.filter(l => l.isLoading());
		
		let message = '';
		if( loadingLayers.length > 1 ) {
			message = `Loading ${loadingLayers.length} layers`; 
		} else if( loadingLayers.length === 1 ) {
			const layer = loadingLayers[0].instance;
			message = `Loading ${layer.getName()}`;
		}
		
		if( message ) {
			this.inner.innerHTML = message;		
		}
		
		this.element.style.display = !message ? "none" : "";
	}
	
}

export {
	LoadingIndicator
}

